import { render, staticRenderFns } from "./InputChangeBDC.vue?vue&type=template&id=933c36ae&scoped=true"
import script from "./InputChangeBDC.vue?vue&type=script&lang=js"
export * from "./InputChangeBDC.vue?vue&type=script&lang=js"
import style0 from "./InputChangeBDC.vue?vue&type=style&index=0&id=933c36ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933c36ae",
  null
  
)

export default component.exports